
const m = window.require("@ember/service");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
